// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 10 10'
    ...attributes
  ><path
      fill='none'
      stroke='var(--icon-color,#000)'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
      d='M1 2h8M2.5 5h5M4 8h2'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'IconFunnel';
export default IconComponent;
